import { get, has, toString } from 'lodash';
import useUIStore, { type INotificationMessage } from '../../modules/layout/store/ui.store';
import type { IApiErrorResponse } from './api-client.service';
import type { AxiosError } from 'axios';

export class UIService {
    constructor(private uiStore = useUIStore()) {
        this.uiStore = uiStore;
    }

    public notifyAction(message: INotificationMessage): void {
        this.uiStore.setNotification(message);
    }

    public notifyApiErrorAction(error: AxiosError<IApiErrorResponse>): void {
        if (!has(error, 'response.data.title') && !has(error, 'response.data.detail')) {
            return;
        }
        this.uiStore.setNotification({
            title: get(error, 'response.data.title') ? toString(get(error, 'response.data.title')) : 'Error!',
            message: get(error, 'response.data.detail')
                ? toString(get(error, 'response.data.detail'))
                : 'Something went wrong. Please try again.',
            type: 'error',
            action: null,
        });
    }
}
